import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { NonEmptyStringSchema } from '../property.models.ts'
import {
  BidIdSchema,
  OfferIdSchema,
  ProjectIdSchema,
  TeamIdSchema,
} from '../unique-id.models.ts'

/**
 * SurveySubjectIdSchema
 */
export const SurveySubjectIdSchema = z.union([
  BidIdSchema,
  OfferIdSchema,
  ProjectIdSchema,
  TeamIdSchema,
])

export type SurveySubjectId = ZodSimplify<typeof SurveySubjectIdSchema>

export const SurveyFeedbackMaxLength = 4096
export const SurveyFeedbackSchema = NonEmptyStringSchema(
  SurveyFeedbackMaxLength
)
export type SurveyFeedback = ZodSimplify<typeof SurveyFeedbackSchema>

export const SurveyRatingMin = 1
export const SurveyRatingMax = 5
export const SurveyRatingSchema = z
  .number()
  .int()
  .min(SurveyRatingMin)
  .max(SurveyRatingMax)
